<!-- ORGANISM: AppBarExtensions.vue -->
<!-- App-bar extension slot — renders the appropriate extension component based on the active page. -->

<script setup lang="ts">
//
// Imports
//

// Vuetify
import { useDisplay } from "vuetify/lib/composables/display.mjs";

// Components
import ValidationExtension from "../molecules/ValidationExtension.vue";
import AboutExtension from "../molecules/AboutExtension.vue";

//
// Composables
//

// Breakpoints
const { smAndDown } = useDisplay();

// App Bar
const { extensionsConfig } = useAppBar();
</script>

<template>
  <div class="ma-4 w-100">
    <!-- Validation Extension -->
    <ValidationExtension v-if="smAndDown && extensionsConfig.component === 'ValidationExtension'" />

    <!-- About Extension -->
    <AboutExtension v-if="extensionsConfig.component === 'AboutExtension'" />
  </div>
</template>
